import React, { PureComponent, useEffect } from "react";
import { useState } from "react";
import { useSelector, useDispatch } from "types/store";
import numeral from "numeral";

import { Button, ButtonGroup, Dropdown, Icon } from "aible";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import Tooltip from "components/Inputs/Tooltip";

import { Modal, Popover, OverlayTrigger } from "react-bootstrap";

import { AutoSizer, Grid } from "react-virtualized";

import styles from "./style.module.css";

const WaterfallBlock = (props = {}) => {
  const { height, width, offset, data, isSmall, onHover, onClick, onMouseLeave } = props;

  let fillColor = "#7E69D7";
  let lineColor = fillColor;
  if (data.color) {
    fillColor = data.color;
    lineColor = fillColor;
  } else if (data?.value > 0) {
    fillColor = "#34D399";
    lineColor = fillColor;
  } else if (data?.value < 0) {
    fillColor = "#FFA4A0";
    lineColor = "#DD5352";
    // if (isSmall) {
    //   fillColor = lineColor;
    // }
  }

  const rawValue = data.rawValue ?? data.value;

  let labelStyle = {
    top: "-20px"
  };
  if (rawValue < 0) {
    labelStyle = {
      top: "100%",
      paddingTop: "5px"
    };
  }

  return (
    <Tooltip
      trigger={["hover"]}
      overlay={
        <div className={styles.waterfallOverlay}>
          <span>{data.label + ": "}</span>
          <strong>{data.displayValue ?? data.value}</strong>
        </div>
      }
    >
      <div
        className={styles.waterfallBlockWrapper}
        onMouseEnter={() => {
          if (onHover) {
            onHover(data?.id);
          }
        }}
        onMouseLeave={() => {
          if (onMouseLeave) {
            onMouseLeave(data?.id);
          }
        }}
        onClick={() => {
          if (onClick) {
            onClick(data?.id);
          }
        }}
        style={{
          cursor: onClick && data?.id ? "pointer" : undefined
        }}
      >
        <div
          className={styles.waterfallBlock}
          style={{
            height: height,
            width: width,
            marginBottom: offset,
            background: fillColor,
            borderColor: lineColor,
            borderWidth: isSmall ? 0 : undefined
          }}
        >
          {!isSmall && data.showLabel && (
            <div className={styles.waterfallBlockLabel} style={labelStyle}>
              {data.displayValue}
            </div>
          )}
        </div>
      </div>
    </Tooltip>
  );
};

const WaterfallAxis = (props = {}) => {
  const { offset, isOffset } = props;

  let fillColor = "#7E7D9ACC";
  let lineColor = fillColor;

  return (
    <div
      className={styles.waterfallAxis}
      style={{
        bottom: offset,
        borderColor: fillColor,
        borderBottomStyle: isOffset ? "dashed" : undefined
      }}
    />
  );
};

const WaterfallChart = (props = {}) => {
  const { data, isSmall, hasAxis, onHover, onMouseLeave, onClick } = props;

  if (!data?.length) {
    return <div />;
  }

  const retData = data.filter((d) => {
    return !isNaN(d.value);
  });

  let isOffset = false;
  const startingBlock = data[0];
  const finalBlock = data[data.length - 1];
  if (startingBlock.isOffset || finalBlock.isOffset) {
    isOffset = true;
  }

  let maxValue = 0;
  let minValue = 0;
  retData.reduce((acc, d) => {
    const value = d.value;
    if (isNaN(value)) {
      return acc;
    }
    acc = d.value + acc;
    if (acc < minValue) {
      minValue = acc;
    }
    if (acc > maxValue) {
      maxValue = acc;
    }
    return acc;
  }, 0);
  const valueRange = Math.abs(maxValue - minValue);

  return (
    <AutoSizer>
      {({ height, width }) => {
        const rawHeight = height;
        const PADDING = 20;
        const hasPadding = !isSmall;
        if (hasPadding) {
          height = rawHeight - PADDING * 2;
        }

        let currValue = 0;
        let blockWidth = 0;
        let blockCount = retData.length;
        blockWidth = width / blockCount;

        let zeroOffset = 0;
        if (maxValue === 0) {
          zeroOffset = height;
        } else if (minValue < 0) {
          zeroOffset = height * Math.abs(minValue / valueRange);
        }

        return (
          <div
            className={styles.waterfallWrapper}
            style={{
              height: height,
              width: width,
              margin: hasPadding ? `${PADDING}px 0px` : undefined
            }}
          >
            <div className={styles.waterfallChart}>
              {retData?.map((d, i) => {
                const blockHeight = height * (Math.abs(d.value) / valueRange);
                const rawOffsetValue = currValue - minValue;
                let retOffsetValue = rawOffsetValue;
                if (d.value < 0) {
                  retOffsetValue = currValue + d.value - minValue;
                }
                const rawOffset = height * (Math.abs(rawOffsetValue) / valueRange);
                const offset = height * (Math.abs(retOffsetValue) / valueRange);

                currValue = currValue + d.value;
                return (
                  <React.Fragment key={"waterfall_" + i}>
                    <WaterfallBlock
                      width={blockWidth}
                      height={blockHeight}
                      offset={offset}
                      data={d}
                      isSmall={isSmall}
                      onClick={onClick}
                      onHover={onHover}
                      onMouseLeave={onMouseLeave}
                    />
                  </React.Fragment>
                );
              })}
              {!isSmall && hasAxis && <WaterfallAxis offset={zeroOffset} isOffset={isOffset} />}
            </div>
          </div>
        );
      }}
    </AutoSizer>
  );
};

export default WaterfallChart;
